/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  ExportSuppliersForOrganizationMutationResponse,
  ExportSuppliersForOrganizationQueryParams,
} from "../types/ExportSuppliersForOrganization.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const exportSuppliersForOrganizationMutationKey = () =>
  [{ url: "/v1/supplier/export-suppliers" }] as const

export type ExportSuppliersForOrganizationMutationKey = ReturnType<
  typeof exportSuppliersForOrganizationMutationKey
>

/**
 * @summary Export organization suppliers monitoring data as CSV
 * {@link /v1/supplier/export-suppliers}
 */
export async function exportSuppliersForOrganization(
  params?: ExportSuppliersForOrganizationQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ExportSuppliersForOrganizationMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/supplier/export-suppliers`,
    params,
    ...requestConfig,
  })
  return res
}

export function exportSuppliersForOrganizationMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = exportSuppliersForOrganizationMutationKey()
  return mutationOptions<
    ResponseConfig<ExportSuppliersForOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportSuppliersForOrganizationQueryParams },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return exportSuppliersForOrganization(params, config)
    },
  })
}

/**
 * @summary Export organization suppliers monitoring data as CSV
 * {@link /v1/supplier/export-suppliers}
 */
export function useExportSuppliersForOrganization<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ExportSuppliersForOrganizationMutationResponse>,
      ResponseErrorConfig<Error>,
      { params?: ExportSuppliersForOrganizationQueryParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? exportSuppliersForOrganizationMutationKey()

  const baseOptions = exportSuppliersForOrganizationMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ExportSuppliersForOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportSuppliersForOrganizationQueryParams },
    TContext
  >

  return useMutation<
    ResponseConfig<ExportSuppliersForOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportSuppliersForOrganizationQueryParams },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ExportSuppliersForOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportSuppliersForOrganizationQueryParams },
    TContext
  >
}
